<div class="d-flex justify-content-end mb-2">
	<button class="btn btn-danger" *ngIf="!showPayed" (click)="showPayed = true">View paid leads</button>
	<button class="btn btn-danger" *ngIf="showPayed" (click)="showPayed = false">View unpaid leads</button>
</div>

<div class="container" *ngIf="loading">
	<div class="col-12" align="top">
		<app-loading></app-loading>
	</div>
</div>
<br>

<div class="container" *ngIf="!showPayed">
	<div class="row" *ngIf="!loading">
		<div class="col-12">
			<app-not-payed-leads #notPayedComponent [payment_provider]="'Authorize'"
				(newCard)="addAuthorizeCustomerModal(add_authorize_customer, $event)"
				(setAch)="openSetAchModal(set_ach_modal, $event)"></app-not-payed-leads>
		</div>
	</div>
</div>

<div class="container" *ngIf="showPayed">
	<div class="row" *ngIf="!loading">
		<div class="col-12">
			<app-payed-leads></app-payed-leads>
		</div>
	</div>
</div>

<!-- ADD AUTHORIZE CUSTOMER FORM MODAL -->
<ng-template #add_authorize_customer let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Add Customer to Authorize.net</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="container">
			<form #addCustomerForm id="addCustomerForm" [formGroup]="customerForm" (ngSubmit)="submitAddCustomerForm()">
				<div class="row">
					<div class="col-12" align="center">
						<app-credit-card-animation style="height: 150px"
							[form]="customerForm"></app-credit-card-animation>
					</div>
				</div>
				<hr />
				<div class="row">
					<div class="col-4">
						<label>Card number:</label>
						<input type="text" class="form-control" formControlName="cardNumber" placeholder="Card Number"
							pattern="[0-9]*" maxlength="20"
							[ngClass]="{ 'is-invalid': isControlInvalid('cardNumber') }" />
					</div>
					<div class="col-4">
						<label>Exp. Date</label><br>
						<input type="text" class="form-control" formControlName="expMonth" placeholder="MM"
							pattern="[0-9]*" [ngClass]="{ 'is-invalid': isControlInvalid('expMonth') }" maxlength="2"
							style="display: inline-block; width: 30%" />
						<span style="display: inline-block; margin-left: 15px; margin-right: 15px"> / </span>
						<input type="text" class="form-control" formControlName="expYear" placeholder="YY"
							pattern="[0-9]*" [ngClass]="{ 'is-invalid': isControlInvalid('expYear') }" maxlength="2"
							style="display: inline-block; width: 30%" />
					</div>
					<div class="col-2">
						<label>CVV</label>
						<input type="text" class="form-control" formControlName="cvv" placeholder="CVV" maxlength="4"
							[ngClass]="{ 'is-invalid': isControlInvalid('cvv') }" />
					</div>
				</div>

				<div class="row">
					<div class="col-4">
						<label>First name:</label>
						<input type="text" class="form-control"
							[ngClass]="{ 'is-invalid': isControlInvalid('firstName') }" formControlName="firstName"
							placeholder="First Name" />
					</div>
					<div class="col-4">
						<label>Last name:</label>
						<input type="text" class="form-control"
							[ngClass]="{ 'is-invalid': isControlInvalid('lastName') }" formControlName="lastName"
							placeholder="Last Name" />
					</div>
				</div>

				<hr />
				<div class="row">
					<div class="col-12">
						<label>Adress:</label>
						<input type="text" class="form-control"
							[ngClass]="{ 'is-invalid': isControlInvalid('address') }" formControlName="address"
							placeholder="Address" />
					</div>
				</div>

				<div class="row">
					<div class="col-3">
						<label>City:</label>
						<input type="text" [ngClass]="{ 'is-invalid': isControlInvalid('city') }" class="form-control"
							formControlName="city" placeholder="City" />
					</div>
					<div class="col-3">
						<label>State:</label>
						<select class="form-control" [ngClass]="{ 'is-invalid': isControlInvalid('state') }"
							formControlName="state">
							<option value="" disabled selected>Select state</option>
							<option [value]="state.smallName" *ngFor="let state of states">{{ state.name }}</option>
						</select>
					</div>
					<div class="col-3">
						<label>Country:</label>
						<input type="text" [ngClass]="{ 'is-invalid': isControlInvalid('country') }"
							class="form-control" formControlName="country" placeholder="Country" />
					</div>
					<div class="col-3">
						<label>Zip Code:</label>
						<input type="text" [ngClass]="{ 'is-invalid': isControlInvalid('zip') }" class="form-control"
							formControlName="zip" placeholder="ZIP" required />
					</div>
				</div>
				<hr />
				<div class="row">
					<div class="col-6">
						<label>Phone Number</label>
						<input type="number" class="form-control"
							[ngClass]="{ 'is-invalid': isControlInvalid('phoneNumber') }" formControlName="phoneNumber"
							placeholder="Phone Number" min="0" required />
					</div>
					<div class="col-6">
						<label>Email:</label>
						<input type="email" class="form-control" [ngClass]="{ 'is-invalid': isControlInvalid('email') }"
							formControlName="email" placeholder="Email" required />
					</div>
				</div>
			</form>
		</div>
	</div>
	<div class="modal-footer p-3">
		<button class="btn btn-default btn-sm" (click)="modal.dismiss('Cross click')">CANCEL</button>
		<button type="submit" form="addCustomerForm" class="btn btn-default btn-sm">Add Customer</button>
	</div>
</ng-template>

<!-- MODAL SET ACH BANK ACCOUNT -->
<ng-template #set_ach_modal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Set ACH Bank Account</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<p>Setting up ACH bank account for alias <strong>{{ selectedLead?.alias }}</strong></p>
		<form [formGroup]="achForm">
			<div class="row">
				<div class="col-md-6 mb-3">
					<label class="form-label">Name on Account <span class="text-danger">*</span></label>
					<input type="text" class="form-control" formControlName="nameOnAccount"
						[ngClass]="{'is-invalid': isAchControlInvalid('nameOnAccount')}"
						placeholder="Full name on bank account" />
					<div class="invalid-feedback">Name on account is required</div>
				</div>
				<div class="col-md-6 mb-3">
					<label class="form-label">Bank Name <span class="text-danger">*</span></label>
					<input type="text" class="form-control" formControlName="bankName"
						[ngClass]="{'is-invalid': isAchControlInvalid('bankName')}"
						placeholder="e.g. Chase, Wells Fargo" />
					<div class="invalid-feedback">Bank name is required</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6 mb-3">
					<label class="form-label">Routing Number <span class="text-danger">*</span></label>
					<input type="text" class="form-control" formControlName="routingNumber"
						[ngClass]="{'is-invalid': isAchControlInvalid('routingNumber')}"
						placeholder="9-digit routing number" maxlength="9" />
					<div class="invalid-feedback">Valid 9-digit routing number is required</div>
				</div>
				<div class="col-md-6 mb-3">
					<label class="form-label">Account Number <span class="text-danger">*</span></label>
					<input type="text" class="form-control" formControlName="accountNumber"
						[ngClass]="{'is-invalid': isAchControlInvalid('accountNumber')}"
						placeholder="Bank account number" />
					<div class="invalid-feedback">Account number is required</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6 mb-3">
					<label class="form-label">Account Type <span class="text-danger">*</span></label>
					<select class="form-select" formControlName="accountType"
						[ngClass]="{'is-invalid': isAchControlInvalid('accountType')}">
						<option value="">Select type</option>
						<option value="CHECKING">Checking</option>
						<option value="SAVINGS">Savings</option>
					</select>
					<div class="invalid-feedback">Account type is required</div>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
		<button type="button" class="btn btn-info waves-effect waves-light" (click)="submitAchForm()">Save ACH</button>
	</div>
</ng-template>

<!-- MODAL WARNING CHARGE-->
<ng-template #chargingModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Charge Lead</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<p style="font-size: 20px;">Charging to alias <strong>{{selectedLead.alias}}</strong> my campaign
			<strong>{{selectedLead.campaign_name}}</strong>
		</p>
		<div *ngIf="loadingPrices" align="center">
			<div class="spinner-border text-primary" role="status">
				<span class="sr-only">Loading...</span>
			</div>
			<p>Loading prices...</p>
		</div>

		<select class="form-control" [(ngModel)]="selectedCost" *ngIf="!loadingPrices" style="font-size: 20px;">
			<option *ngFor="let price of prices" [value]="price.description+' - '+price.price">{{price.description}} -
				<strong>{{price.price | currency: 'USD'}}</strong>
			</option>
		</select>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-dark waves-effect waves-light" (click)="chargeAuthorizeNet();"
			[disabled]="loadingCharge">Charge</button>
	</div>
</ng-template>
